<div class="container">

    <div class="log-header">
        <img src="./assets/CAISOlogo.jpg">
    </div>

    <h1>Manage email notifications</h1>
    <p *ngIf="!requestFailed">Update your email subscription preferences and click Submit.</p>

    <div class="container px-2 pt-2">

        <div id="divPageProgress" class="row loaderDiv" *ngIf="!dataLoaded">
            <div class="col-12 text-center">
                <div class="text-primary progressAnimation">
                    <div class="loader"></div>
                </div>
            </div>
        </div>



        <div *ngIf="requestProcessed || requestFailed" class="operationMessage"
            [ngClass]="{'failedRequestMessage' : requestFailed}">
            {{messageToDisplay}}
        </div>


        <form #subscriptionForm="ngForm" (ngSubmit)="submit(subscriptionForm)"
            *ngIf="(!requestProcessed && !requestFailed) && dataLoaded">
            <div class="form-group mt-2">
                <label for="firstName" *ngIf="model.firstName">First name</label>
                <span class="userText">{{model.firstName}}</span>
            </div>
            <div class="form-group  mt-2">
                <label for="lastName" *ngIf="model.lastName">Last name</label>
                <span class="userText">{{model.lastName}}</span>
            </div>
            <div class="form-group mt-2">
                <label for="emailAddress">Email address</label>
                <span class="userText">{{model.emailAddress}}</span>
            </div>
            <div class="form-group mt-2" *ngIf="model.organization">
                <label for="organization">Organization</label>
                <span class="userText">{{model.organization}}</span>
            </div>
            
            <div class="form-group mt-2">
                <label for="eventNames">Subscribe to:</label>

                <div *ngFor="let evt of isoEvents; let i=index" class="col-md-2">
                    <label class="eventText ps-2 p1-1">
                        <input type="checkbox" [value]="evt.eventName" (change)="onEventSelectionChange($event)"
                            [checked]="model.eventNames.indexOf(evt.eventName)>=0">
                        {{evt.eventName}}
                    </label>
                </div>
            </div>

            <hr>
            <button class="btn btn-primary mt-4" type="submit">Submit</button>
        </form>
    </div>
</div>